/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1MylibraryPeople202,
  PostApiV1MylibraryPeople400,
  PostApiV1MylibraryPeople401,
  PostApiV1MylibraryPeople500,
  PostApiV1MylibraryPeopleMutationRequest,
  PostApiV1MylibraryPeopleMutationResponse,
} from "../../types/myLibraryManutenoController/PostApiV1MylibraryPeople.ts";
import { addMyLibraryPeopleRequestViewModelSchema } from "../addMyLibraryPeopleRequestViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1MylibraryPeople202Schema =
  z.boolean() as unknown as ToZod<PostApiV1MylibraryPeople202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1MylibraryPeople400Schema =
  z.any() as unknown as ToZod<PostApiV1MylibraryPeople400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1MylibraryPeople401Schema =
  z.any() as unknown as ToZod<PostApiV1MylibraryPeople401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1MylibraryPeople500Schema =
  z.any() as unknown as ToZod<PostApiV1MylibraryPeople500>;

export const postApiV1MylibraryPeopleMutationRequestSchema = z.lazy(
  () => addMyLibraryPeopleRequestViewModelSchema,
) as unknown as ToZod<PostApiV1MylibraryPeopleMutationRequest>;

export const postApiV1MylibraryPeopleMutationResponseSchema = z.lazy(
  () => postApiV1MylibraryPeople202Schema,
) as unknown as ToZod<PostApiV1MylibraryPeopleMutationResponse>;
